export default function Mail() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M69.6204 22.4243L41.5877 40.2377C40.6229 40.8422 39.5074 41.1628 38.3688 41.1628C37.2303 41.1628 36.1147 40.8422 35.1499 40.2377L7.11719 22.4243M13.3675 13.0488H63.3701C66.8221 13.0488 69.6204 15.8472 69.6204 19.2992V56.8011C69.6204 60.2531 66.8221 63.0514 63.3701 63.0514H13.3675C9.91555 63.0514 7.11719 60.2531 7.11719 56.8011V19.2992C7.11719 15.8472 9.91555 13.0488 13.3675 13.0488Z" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}